import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import * as InventoryActions from './inventory.actions';
import { Inventory } from './inventory.models';

export const INVENTORY_FEATURE_KEY = 'inventory';

export interface State {
    items: Inventory[];
    loaded: boolean; // has the Inventory list been loaded
    error: string | null; // last known error (if any)
}

export const initialState: State = {
    items: [],
    loaded: false,
    error: null
};

export const inventoryFeature = createFeature({
    name: INVENTORY_FEATURE_KEY,
    reducer: createReducer(
        initialState,
        on(
            InventoryActions.init,
            (state): State => ({
                ...state,
                loaded: false,
                error: null
            })
        ),
        on(
            InventoryActions.loadInventorySuccess,
            (state, { items }): State => ({
                ...state,
                items,
                loaded: true,
                error: null
            })
        ),
        on(InventoryActions.loadInventoryFailure, (state, { error }): State => ({ ...state, error }))
    )
});

export const { name, reducer, selectInventoryState, selectItems, selectLoaded, selectError } = inventoryFeature;

export const selectItemQuantityInStock = (productId: number) =>
    createSelector(selectItems, items => {
        const item = items?.find(item => item.product_id === productId);
        return item ? item.quantity_in_stock : 0;
    });
